import axios from "axios";
import { API_URL } from "../../../config/api";

// Interfaces
interface LoginCredentials {
  email: string;
  password: string;
}

interface RegisterData {
  name: string;
  email: string;
  password: string;
  userImg?: string;
  phone?: string;
  cpf?: string;
}

interface AuthResponse {
  success: boolean;
  data: {
    user: {
      id: number;
      name: string;
      email: string;
      phone?: string;
      cpf?: string;
      userImg?: string;
      created_at: string;
      updated_at: string;
    };
    token: string;
  };
  message?: string;
}

const api = axios.create({
  baseURL: API_URL,
});

const AccountService = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    try {
      const response = await api.post<AuthResponse>("/api/auth/login", credentials);
      return response.data;
    } catch (error) {
      console.error("Error in Account.login:", error);
      throw error;
    }
  },

  register: async (data: RegisterData): Promise<AuthResponse> => {
    try {
      const response = await api.post<AuthResponse>("/api/auth/register", data);
      return response.data;
    } catch (error) {
      console.error("Error during user registration:", error);
      throw error;
    }
  },
};

export default AccountService;
export type { LoginCredentials, RegisterData, AuthResponse }; 